module.exports = __webpack_public_path__ + "static/1-Home-page-c7978f03a5027a6fe6c8404061593201.svg";